import React from 'react';
import { Calendar, CheckCircle, XCircle } from 'lucide-react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';

const LeaveApprovalsWidget = ({ leaves, onRefresh }) => {
  const handleApprove = async (leaveId, status, remarks = '') => {
    try {
      await updateDoc(doc(db, 'leaves', leaveId), {
        status: status,
        approvedAt: new Date(),
        approvalRemarks: remarks
      });
      alert(`Leave ${status}!`);
      onRefresh();
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to process leave');
    }
  };

  if (leaves.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <Calendar className="w-12 h-12 mx-auto mb-2 text-gray-300" />
        <p>No pending leave requests</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {leaves.map(leave => (
        <div key={leave.id} className="border rounded-lg p-4">
          <div className="mb-3">
            <div className="flex items-center space-x-2 mb-2">
              <span className="font-semibold text-blue-600">{leave.rollNumber}</span>
              <span className="text-gray-600">|</span>
              <span className="text-gray-900">{leave.studentName}</span>
            </div>
            <div className="text-sm text-gray-600 space-y-1">
              <p><strong>From:</strong> {new Date(leave.fromDate).toLocaleDateString()}</p>
              <p><strong>To:</strong> {new Date(leave.toDate).toLocaleDateString()}</p>
              <p><strong>Type:</strong> {leave.leaveType}</p>
              <p><strong>Reason:</strong> {leave.reason}</p>
            </div>
          </div>
          
          <div className="flex space-x-2">
            <button
              onClick={() => handleApprove(leave.id, 'approved')}
              className="flex-1 flex items-center justify-center space-x-2 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            >
              <CheckCircle className="w-4 h-4" />
              <span>Approve</span>
            </button>
            <button
              onClick={() => {
                const remarks = prompt('Reason for rejection:');
                if (remarks) handleApprove(leave.id, 'rejected', remarks);
              }}
              className="flex-1 flex items-center justify-center space-x-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            >
              <XCircle className="w-4 h-4" />
              <span>Reject</span>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LeaveApprovalsWidget;